import { Outlet } from 'react-router-dom';
import {
  ClipboardText, Receipt, Truck, ClockCounterClockwise, Barcode, ArrowsClockwise,
  Scales, ShieldCheck, Kanban as KanbanIcon, Hash, Plus, Gear, Package,
} from '@phosphor-icons/react';
import { ModuleSidebar } from '@/components/enterprise/ModuleSidebar';

// Workflow-oriented navigation (Jun 2026): one primary workflow per screen.
// メイン = the daily loop (browse → create → approve → order → track).
// その他 / 管理 = lower-frequency and administrative screens.
const SECTIONS = [
  {
    label: 'メイン',
    items: [
      { to: '/shizai', end: true, label: 'ダッシュボード', icon: Package, testid: 'shizai-nav-dashboard' },
      { to: '/shizai/requests', end: true, label: '依頼一覧', icon: ClipboardText, testid: 'shizai-nav-requests' },
      { to: '/shizai/requests/new', label: '新規依頼作成', icon: Plus, testid: 'shizai-nav-request-new' },
      { to: '/shizai/approvals', label: '承認待ち', icon: ShieldCheck, testid: 'shizai-nav-approvals' },
      { to: '/shizai/orders', label: '発注一覧', icon: Receipt, testid: 'shizai-nav-orders' },
      { to: '/shizai/kanban', label: 'かんばん', icon: KanbanIcon, testid: 'shizai-nav-kanban' },
      { to: '/shizai/settings', label: '設定', icon: Gear, testid: 'shizai-nav-settings' },
    ],
  },
  {
    label: 'その他 / 管理',
    items: [
      { to: '/shizai/receiving', label: '入荷', icon: Barcode, testid: 'shizai-nav-receiving' },
      { to: '/shizai/invoices', label: '請求照合', icon: Scales, testid: 'shizai-nav-invoices' },
      { to: '/shizai/reorder', label: '発注候補', icon: ArrowsClockwise, testid: 'shizai-nav-reorder' },
      { to: '/shizai/history', label: '履歴', icon: ClockCounterClockwise, testid: 'shizai-nav-history' },
      { to: '/settings/data-audit', label: 'データ点検', icon: ClipboardText, testid: 'shizai-nav-purchase-records' },
      { to: '/shizai/suppliers', label: '仕入先', icon: Truck, testid: 'shizai-nav-suppliers' },
      { to: '/shizai/sku-generator', label: '品番発番', icon: Hash, testid: 'shizai-nav-sku-generator' },
    ],
  },
];

export default function ShizaiLayout() {
  return (
    <div className="flex flex-col md:flex-row gap-5 md:gap-6" data-testid="shizai-layout">
      <ModuleSidebar
        icon={Package}
        title="資材"
        subtitle={undefined}
        sections={SECTIONS}
        testid="shizai-sidebar"
      />
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
